module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      siteBasket: true, active: _vm.active
    },
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "innerCart"
  }, [(!_vm.articles.length) ? _c('div', [_c('div', {
    staticClass: "emptyText"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("emptyBasket")) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "checkout black adapted button full-width",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("close")) + "\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.articles.length) ? _c('div', {
    staticClass: "full-height"
  }, [_c('div', {
    staticClass: "hide-for-desktop"
  }, [_c('a', {
    attrs: {
      "href": "/cgi-bin/ibutik/AIR_ibutik.fcgi?funk=bestall_steg1"
    }
  }, [_c('div', {
    staticClass: "checkout black adapted button full-width"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("checkout")) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "topSummary title hide-for-desktop float-left full-width large-spacing-top large-spacing-bottom"
  }, [_c('div', {
    staticClass: "totalPrice spacing-bottom float-left full-width"
  }, [_c('span', {
    staticClass: "txt float-left medium-large-text price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("total")) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "cart-totalprice float-right"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.data.sum) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffix'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "freeShipping float-left full-width small-text"
  })]), _vm._v(" "), _c('div', {
    staticClass: "siteBasketArticles"
  }, _vm._l((_vm.articles), function(article) {
    return _c('div', {
      key: article.id,
      staticClass: "articleRow"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImageDB(article)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "information"
    }, [_c('div', {
      staticClass: "name ellipsis title"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.title) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('div', {
      class: {
        originalPrice: true, oldPrice: article.campaignPrice
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.price) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]), _vm._v(" "), (article.campaignPrice) ? _c('div', {
      class: {
        newPrice: true
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.campaignPrice) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "qty style-forms"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (article.quantity),
        expression: "article.quantity"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(article, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.changeQty(article, false, $event)
        }]
      }
    }, _vm._l((10), function(i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(i) + "\n\t\t\t\t\t\t\t\t")])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.changeQty(article, true, $event)
        }
      }
    }, [(_vm.removeLoading[article.id]) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }) : _vm._e(), _vm._v(" "), (!_vm.removeLoading[article.id]) ? _c('i', {
      staticClass: "fa fa-trash"
    }) : _vm._e()])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "bottomSummary title show-for-desktop float-left full-width"
  }, [_c('div', {
    staticClass: "totalPrice float-left full-width"
  }, [_c('span', {
    staticClass: "txt float-left normal-text price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("total")))]), _vm._v(" "), _c('span', {
    staticClass: "cart-totalprice float-right price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.data.sumPrefix) + _vm._s(Math.round(_vm.data.sum * 100) / 100) + _vm._s(_vm.data.sumSuffix) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.checkoutUrl
    }
  }, [_c('div', {
    staticClass: "checkout black adapted button full-width"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("checkout")) + "\n\t\t\t\t\t")])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12a84582!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Basket/SiteBasket.vue
// module id = 146
// module chunks = 0